import { injectIntl } from 'react-intl';
import { formValues } from 'utils/formValues';
import IdentityVerification from '../IdentityVerification/IdentityVerification';
import config from './config';

export const CONFIG = config;

export default injectIntl(formValues('indvIdentMethod', 'bankingAccount')(IdentityVerification));
